import PhotoSwipeLightbox from 'photoswipe/lightbox';

$(() => {
    if (!(window.gsap && window.ScrollTrigger)) {
        return;
    }
    window.gsap.registerPlugin(window.ScrollTrigger);

    var galleryElement = document.querySelector('.wp-block-gallery');

    if (galleryElement) {
    galleryElement.classList.add('swiper__contentrij');

    var figures = galleryElement.querySelectorAll('figure');

    figures.forEach(function(figure) {
        figure.classList.add('swiper-slide');
    });

    var wrapperDiv = document.createElement('div');
    wrapperDiv.classList.add('swiper-wrapper', 'swiper-wrapper-gallery');

    figures.forEach(function(figure) {
        wrapperDiv.appendChild(figure);
    });

    galleryElement.appendChild(wrapperDiv);

    // Add the swiper-button-prev and swiper-button-next elements
    var buttonPrev = document.createElement('div');
    buttonPrev.classList.add('swiper-button-prev', 'swiper-button-prev--gallery');

    var buttonNext = document.createElement('div');
    buttonNext.classList.add('swiper-button-next', 'swiper-button-next--gallery');

    galleryElement.appendChild(buttonPrev);
    galleryElement.appendChild(buttonNext);
    }

    // // Get all elements with the classname 'wp-block-gallery'
    // var galleryElements = document.querySelectorAll('.wp-block-gallery');

    // // Loop through each gallery element
    // for (var galleryElement of galleryElements) {
    // // Get all figures inside the current gallery element
    // var figures = galleryElement.querySelectorAll('figure');

    // // Loop through each figure inside the current gallery element
    // for (var figure of figures) {
    //     // Get the img element within the figure
    //     var imgElement = figure.querySelector('img');
    //     if (imgElement) {
    //     var srcUrl = imgElement.src;
        
    //     // Create a new anchor element
    //     var linkElement = document.createElement('a');
    //     linkElement.href = srcUrl;
    //     linkElement.setAttribute('data-pswp-width', '1024');
    //     linkElement.setAttribute('data-pswp-height', '683');
        
    //     // Append the img element to the anchor element
    //     linkElement.appendChild(imgElement);
        
    //     // Replace the img element in the figure with the anchor element
    //     figure.innerHTML = linkElement.outerHTML;
        
    //     // Update the data-pswp-src attribute to the anchor element
    //     figure.setAttribute('data-pswp-src', linkElement.href);
    //     }
    // }
    // }

    // var element = document.querySelector('.swiper-wrapper-gallery');
    // if (element) {
    //     element.id = 'wp-block-gallerypopup';
    // }

    // // Wrap the PhotoSwipeLightbox initialization in a function
    // function initializeLightbox() {
    //     const lightbox3 = new PhotoSwipeLightbox({
    //         gallery: '#wp-block-gallerypopup',
    //         children: 'a',
    //         showHideAnimationType: 'fade',
    //         pswpModule: () => import('photoswipe')
    //     });
    //     lightbox3.init();
    // }

    // // Check if the PhotoSwipe module has already been loaded
    // if (window.PhotoSwipe) {
    // initializeLightbox();
    // } else {
    // // Load the PhotoSwipe module asynchronously
    // import('photoswipe').then(initializeLightbox);
    // }

    if(document.querySelector(".swiper__contentrij")) {
        const blocksSwiperGallery = new Swiper('.swiper__contentrij', {
            direction: 'horizontal',
            slidesPerView: 1,
            spaceBetween: 30,
            speed: 1000,
            loop: true,
            autoplay: {
                delay: 5000,
            },
            navigation: {
                nextEl: '.swiper-button-next--gallery',
                prevEl: '.swiper-button-prev--gallery',
            },
            breakpoints: {
                640: {
                slidesPerView: 2,
                spaceBetween: 20,
                },
                1024: {
                slidesPerView: 3,
                spaceBetween: 50,
                },
            },
        });
    }

    setTimeout(() => {
        if (document.querySelector(".swiper__logos")) {
            const logoSwiper = new Swiper('.swiper__logos', {
                direction: 'horizontal',
                slidesPerView: 2,
                spaceBetween: 30,
                speed: 1000,
                loop: true,
                autoplay: {
                    delay:2500,
                },
                navigation: {
                    nextEl: '.swiper-button-next-logos',
                    prevEl: '.swiper-button-prev-logos',
                },
                watchOverflow: false,
                loopAdditionalSlides: 1,
                breakpoints: {
                    640: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                    },

                    1024: {
                        slidesPerView: 4,
                        spaceBetween: 20,
                    },
      
                    1330: {
                        slidesPerView: 6,
                        spaceBetween: 30,
                    },
                },
            });

            console.log('Swiper init met', document.querySelectorAll('.swiper__logos .swiper-slide').length, 'slides');
        }
    }, 200); 

    // CONTENTRIJEN ANIMATIONS

    if(document.querySelector(".swiper-wrapper-gallery")) {
        gsap.to(".wp-block-image", {
            scrollTrigger: {
                trigger: ".swiper-wrapper-gallery"
            },
            y: 0,
            opacity: 1,
            duration: 0.2,
            stagger: 0.1
        })
    }

    if(document.querySelector(".graatieus__block--gallery")) {
        gsap.to(".graatieus__block--gallery", {
            scrollTrigger: {
                trigger: ".graatieus__block--gallery"
            },
            y: 0,
            opacity: 1,
            duration: 0.5,
        })
    }

    if(document.querySelector(".graatieus__block--titleleft")) {
        gsap.to(".graatieus__block--titleleft", {
            scrollTrigger: {
                trigger: ".graatieus__block--titleleft"
            },
            y: 0,
            opacity: 1,
            duration: 0.5,
        })
    }

    if(document.querySelector(".graatieus__block--fullimage")) {
        gsap.to(".graatieus__block--fullimage", {
            scrollTrigger: {
                trigger: ".graatieus__block--fullimage"
            },
            y: 0,
            opacity: 1,
            duration: 0.5,
        })
    }

    if(document.querySelector(".graatieus__block--cta")) {
        gsap.to(".graatieus__block--cta", {
            scrollTrigger: {
                trigger: ".graatieus__block--cta"
            },
            y: 0,
            opacity: 1,
            duration: 0.5,
        })
    }

    if(document.querySelector(".graatieus__block--texttwo")) {
        gsap.to(".graatieus__block--texttwo", {
            scrollTrigger: {
                trigger: ".graatieus__block--texttwo"
            },
            y: 0,
            opacity: 1,
            duration: 0.5,
        })
    }

    if(document.querySelector(".graatieus__block--texttwo--gray")) {
        gsap.to(".graatieus__block--texttwo--gray", {
            scrollTrigger: {
                trigger: ".graatieus__block--texttwo--gray"
            },
            y: 0,
            opacity: 1,
            duration: 0.5,
        })
    }

    if(document.querySelector(".graatieus__block--contentblocks")) {
        gsap.to(".graatieus__block--contentblocks", {
            scrollTrigger: {
                trigger: ".graatieus__block--contentblocks"
            },
            y: 0,
            opacity: 1,
            duration: 0.5,
        })
    }

    if(document.querySelector(".graatieus__block--gradientblock")) {
        gsap.to(".graatieus__block--gradientblock", {
            scrollTrigger: {
                trigger: ".graatieus__block--gradientblock"
            },
            y: 0,
            opacity: 1,
            duration: 0.5,
        })
    }

    if(document.querySelector(".wp-block-embed")) {
        gsap.to(".wp-block-embed", {
            scrollTrigger: {
                trigger: ".wp-block-embed"
            },
            y: 0,
            opacity: 1,
            duration: 0.5,
        })
    }

    var parentElements = document.querySelectorAll(".graatieus__block--imageleft");
    
    parentElements.forEach(function(parentElement) {
        var columnElements = parentElement.querySelectorAll(".wp-block-column");
        
        columnElements.forEach(function(columnElement) {
        columnElement.classList.add("wp-block-column--hidden");
        columnElement.classList.remove("wp-block-column");
        });
    });

    var parentElements2 = document.querySelectorAll(".graatieus__block--imageright");
    
    parentElements2.forEach(function(parentElement2) {
        var columnElements2 = parentElement2.querySelectorAll(".wp-block-column");
        
        columnElements2.forEach(function(columnElement2) {
        columnElement2.classList.add("wp-block-column--hidden--two");
        columnElement2.classList.remove("wp-block-column");
        });
    });


    if(document.querySelector(".wp-block-column--hidden")) {
        gsap.to(".wp-block-column--hidden", {
            scrollTrigger: {
                trigger: ".graatieus__block--imageleft"
            },
            x: 0,
            y: 0,
            opacity: 1,
            stagger: 0.2,
            duration: 0.5,
        })
    }

    if(document.querySelector(".wp-block-column--hidden--two")) {
        gsap.to(".wp-block-column--hidden--two", {
            scrollTrigger: {
                trigger: ".graatieus__block--imageright"
            },
            x: 0,
            y: 0,
            opacity: 1,
            stagger: 0.2,
            duration: 0.5
        })
    }

    if(document.querySelector(".wp-block-column")) {
        gsap.to(".wp-block-column", {
            scrollTrigger: {
                trigger: ".wp-block-column"
            },
            delay: 0.3,
            y: 0,
            opacity: 1,
            duration: 0.3,
            stagger: 0.2
        })
    }

    if(document.querySelector(".header")) {
        gsap.to(".header", {
            delay: 0.3,
            opacity: 1,
            duration: 0.3
        })
    }

    if(document.querySelector(".slider__overlay")) {
        gsap.to(".slider__overlay", {
            opacity: 1,
            duration: 0.3
        })
    }

    if(document.querySelector(".banner__title")) {
        gsap.to(".banner__title", {
            delay: 0,
            opacity: 1,
            y: 1,
            duration: 0.3
        })
    }

    if(document.querySelector(".banner__smalltitle")) {
        gsap.to(".banner__smalltitle", {
            delay: 0.1,
            opacity: 1,
            y: 1,
            duration: 0.3
        })
    }

    if(document.querySelector(".banner__subtitle")) {
        gsap.to(".banner__subtitle", {
            delay: 0.2,
            opacity: 1,
            y: 1,
            duration: 0.3
        })
    }

    if(document.querySelector(".banner__btns")) {
        gsap.to(".banner__btns", {
            delay: 0.3,
            opacity: 1,
            y: 1,
            duration: 0.3
        })
    }


    var blocks = $('.graatieus__block, .wp-block-gallery, .wp-block-embed');
    var mainDiv = $('#project__main');
    
    blocks.appendTo(mainDiv);

    if(document.querySelector(".usp__item")) {
        gsap.to(".usp__item", {
            delay: 0,
            opacity: 1,
            y: 0,
            stagger: 0.15,
            duration: 0.15
        })
    }

    if(document.querySelector(".dienst__block")) {
        gsap.to(".dienst__block", {
            delay: 1.6,
            opacity: 1,
            y: 0,
            stagger: 0.15,
            duration: 0.3
        })
    }

    if(document.querySelector(".testimonials__layer")) {
        gsap.to(".testimonials__layer", {
            scrollTrigger: {
                trigger: ".testimonials__layer"
            },
            y: 0,
            opacity: 1,
            duration: 0.5,
        })
    }

    if(document.querySelector(".swiper-button-prev--testimonials")) {
        gsap.to(".swiper-button-prev--testimonials", {
            scrollTrigger: {
                trigger: ".testimonials__layer"
            },
            y: 0,
            opacity: 1,
            duration: 0.3,
        })
    }

    if(document.querySelector(".swiper-button-next--testimonials")) {
        gsap.to(".swiper-button-next--testimonials", {
            scrollTrigger: {
                trigger: ".testimonials__layer"
            },
            y: 0,
            opacity: 1,
            duration: 0.3,
        })
    }


    if(document.querySelector(".testimonials__inner")) {
        const testimonials = new Swiper('.testimonials__inner', {
            direction: 'horizontal',
            loop: true,
            spaceBetween: '350',
            autoHeight: true,
            allowTouchMove: false,
            centeredSlides: true,
            autoplay: {
                delay: 8000,
                disableOnInteraction: false, 
            },
            speed: 1000,
            navigation: {
                nextEl: '.swiper-button-next--testimonials',
                prevEl: '.swiper-button-prev--testimonials',
            },
            slidesPerView: 1,
            on: {
                init: function () {
                    // Start de observer om veranderingen in de Swiper-container te volgen
                    const observer = new IntersectionObserver((entries) => {
                        entries.forEach((entry) => {
                            if (entry.isIntersecting) {
                                testimonials.autoplay.start(); // Gebruik 'testimonials' in plaats van 'swiper'
                            } else {
                                testimonials.autoplay.stop(); // Gebruik 'testimonials' in plaats van 'swiper'
                            }
                        });
                    });

                    // Voeg de Swiper-container toe aan de observer
                    observer.observe(this.el);
                }
            }
        })
    }

    // HOME PROJECTS

    if (document.querySelector(".home__projects__big__title")) {
        // Stel de gewenste opaciteit in afhankelijk van de schermgrootte
        var targetOpacity = window.innerWidth < 1024 ? 1 : 0.1;

        gsap.to(".home__projects__big__title", {
            scrollTrigger: {
                trigger: ".contentrow__projects",   // <— hier aangepast
            },
            y: 0,
            opacity: targetOpacity,
            duration: 0.5,
        });
    }

    if (document.querySelector(".home__project__left")) {
        gsap.to(".home__project__left", {
            scrollTrigger: {
                trigger: ".contentrow__projects",   // <— hier aangepast
            },
            x: 0,
            delay: 0.5,
            opacity: 1,
            duration: 0.5,
        });
    }

    if (document.querySelector(".home__project__right")) {
        gsap.to(".home__project__right", {
            scrollTrigger: {
                trigger: ".contentrow__projects",   // <— hier aangepast
            },
            x: 0,
            delay: 1,
            opacity: 1,
            duration: 0.5,
        });
    }

    if(document.querySelector(".cta__gradient")) {
        gsap.to(".cta__gradient", {
            scrollTrigger: {
                trigger: ".cta__gradient"
            },
            y: 0,
            opacity: 1,
            duration: 0.5,
        })
    }

    if(document.querySelector(".cta__left h3")) {
        gsap.to(".cta__left h3", {
            scrollTrigger: {
                trigger: ".cta__gradient"
            },
            y: 0,
            delay: 0.1,
            opacity: 1,
            duration: 0.3,
        })
    }

    if(document.querySelector(".cta__left li")) {
        gsap.to(".cta__left li", {
            scrollTrigger: {
                trigger: ".cta__gradient"
            },
            y: 0,
            stagger: 0.15,
            delay: 0.2,
            opacity: 1,
            duration: 0.15,
        })
    }

    if(document.querySelector(".cta__buttons")) {
        gsap.to(".cta__buttons", {
            scrollTrigger: {
                trigger: ".cta__gradient"
            },
            y: 0,
            delay: 0,
            opacity: 1,
            duration: 0.15,
        })
    }

    if(document.querySelector(".cta__right")) {
        gsap.to(".cta__right", {
            scrollTrigger: {
                trigger: ".cta__gradient"
            },
            y: 0,
            delay: 0.3,
            opacity: 1,
            duration: 0.3,
        })
    }

    if(document.querySelector(".intro__news__home")) {
        gsap.to(".intro__news__home", {
            scrollTrigger: {
                trigger: ".news__home__container"
            },
            y: 0,
            opacity: 1,
            duration: 0.5,
        })
    }

    if(document.querySelector(".news__left")) {
        gsap.to(".news__left", {
            scrollTrigger: {
                trigger: ".news__home__container"
            },
            y: 0,
            delay: 1,
            opacity: 1,
            duration: 0.5,
        })
    }

    if(document.querySelector(".news__tiny")) {
        gsap.to(".news__tiny", {
            scrollTrigger: {
                trigger: ".news__home__container"
            },
            y: 0,
            delay: 1.5,
            stagger: 0.3,
            opacity: 1,
            duration: 0.5,
        })
    }

    if(document.querySelector(".certificates__left")) {
        gsap.to(".certificates__left", {
            scrollTrigger: {
                trigger: ".certificates__container"
            },
            delay: 0,
            y: 0,
            opacity: 1,
            duration: 0.3,
        })
    }

    if(document.querySelector(".certificate__block")) {
        gsap.to(".certificate__block", {
            scrollTrigger: {
                trigger: ".certificates__container"
            },
            delay: 0.3,
            y: 0,
            stagger: 0.15,
            opacity: 1,
            duration: 0.15,
        })
    }

    // if(document.querySelector(".footer__col")) {
    //     gsap.to(".footer__col", {
    //         scrollTrigger: {
    //             trigger: ".footer__top"
    //         },
    //         delay: 0.5,
    //         y: 0,
    //         stagger: 0.15,
    //         opacity: 1,
    //         duration: 0.3,
    //     })
    // }

});
